<template>
  <div class="modal fade" id="specificStudentListModal" tabindex="-1" aria-labelledby="specificStudentListModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="specificStudentListModalLabel">List of students</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="loading" class="text-center my-4">
            <div class="spinner-border" role="status">
              <span class="sr-only">&nbsp;&nbsp;Loading...</span>
            </div>
          </div>
          <div v-else>
            <input v-model="searchQuery" type="text" class="form-control mb-3" placeholder="Search by UCO" />
            <div class="list-group">
              <div v-for="item in paginatedStudents" :key="item.student_id" class="list-group-item d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <span>{{ item.student_uco }}</span>
                  <!-- AI-review confidence (bucket + %) and approval, inline per student (#66) -->
                  <span
                    v-if="item.confidencePercent !== null"
                    class="badge"
                    :class="item.confidenceClass"
                    title="AI-review model confidence"
                  >
                    {{ item.confidenceBucket }} · {{ item.confidencePercent }}%
                  </span>
                  <span
                    v-if="item.ai_review_approved === true"
                    class="badge bg-success"
                    title="AI review approved by a teacher"
                  >
                    <i class="bi bi-check-circle"></i> Approved
                  </span>
                </div>
                <button class="btn btn-primary btn-sm" @click="handleRedirect(item.evaluation_id)">
                  Go to Evaluation
                </button>
              </div>
            </div>
            <div class="d-flex justify-content-between mt-3">
                <button class="btn btn-secondary btn-sm" :disabled="currentPage === 1" @click="prevPage">
                <i class="bi bi-arrow-left"></i> Previous
                </button>
                <span>Page {{ currentPage }} of {{ totalPages }}</span>
                <button class="btn btn-secondary btn-sm" :disabled="currentPage === totalPages" @click="nextPage">
                Next <i class="bi bi-arrow-right"></i>
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <StemErrorModal ref="stemErrorModal" />
</template>
  
<script>
import { Modal } from 'bootstrap';
import StemErrorModal from '@/components/StemErrorModal.vue';
import SubEvaluationController from '@/controllers/SubEvaluationController';
import SpecifiedDeadlineSubtaskResultType from '@/models/subEvaluation';

export default {
  name: 'specificStudentListModal',
  props: {
    specifiedData: {
      type: SpecifiedDeadlineSubtaskResultType,
      required: true
    },
    onRedirectEvaluation: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      listOfStudents: [],
      loading: true,
      currentPage: 1,
      pageSize: 10,
      searchQuery: "",
    };
  },
  components: {
    StemErrorModal,
  },
  watch: {
    specifiedData: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchStudents();
        }
      }
    },
    searchQuery() {
      this.currentPage = 1;
    }
  },
  computed: {
    filteredStudents() {
      if (!this.searchQuery.trim()) {
        return this.listOfStudents;
      }
      const query = this.searchQuery.toLowerCase();
      return this.listOfStudents.filter(item =>
        String(item.student_uco).toLowerCase().includes(query)
      );
    },
    paginatedStudents() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredStudents.slice(start, start + this.pageSize);
    },
    totalPages() {
      return Math.ceil(this.filteredStudents.length / this.pageSize) || 1;
    },
  },
  methods: {
    async fetchStudents() {
      this.loading = true;
      this.currentPage = 1;
      try {
        this.listOfStudents = await SubEvaluationController.fetchListOfStudentsForSpecificDeadlineSubtaskAndSubevaluationResult(this.specifiedData);
      } catch (error) {
        this.$refs.stemErrorModal.show('Error', error.message);
      } finally {
        this.loading = false;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    handleRedirect(evaluationId) {
      this.onRedirectEvaluation(evaluationId);
      const modalEl = document.getElementById('specificStudentListModal');
      const modalInstance = Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();
      } else {
        new Modal(modalEl).hide();
      }
    },
    resetForm() {
      this.searchQuery = "";
      this.listOfStudents = [];
      this.loading = true;
    },
  },
  mounted() {
    const modalElement = document.getElementById('specificStudentListModal');
    modalElement.addEventListener('hidden.bs.modal', this.resetForm);
  }
}
</script>